import React from "react"
import {connect} from "react-redux";

import Moment from "react-moment";
import {Row, Table} from "reactstrap";
import * as auth from "../../utils/auth";
import InfoBox from "../InfoBox";
import {fetchVerifications} from "../../actions/depositActions";
import {fetchRecents} from "../../actions/dashboardActions";
import {Link} from "react-router-dom";
import {push} from "connected-react-router";

class Dashboard extends React.Component {

  componentWillMount() {
    this.props.fetchRecents()
  }

  render() {
    const Status = ({status}) => (
      <span className='float-right'>
        {status}
        <span style={{color: status === 'failed' ? '#ff2e00'
            : status === 'warning' ? '#ffbf00'
              : status === 'running' ? '#4fb8ff'
                : '#57d500',
          transition: 'all .3s ease'
        }}> &#x25cf;</span>
      </span>
    )

    let user = auth.get_user();

    if (user)
      return <Row>
        <InfoBox xs={6} title="Recent verifications (last 20)">
          <Table size='sm' hover>
            <thead>
              <tr>
                <th>Date created</th>
                <th>SF Contract Id</th>
                <th>SF Product</th>
                <th style={{textAlign: 'right'}}>Verification status</th>
              </tr>
            </thead>
            <tbody>
              {this.props.recentVerifications.map((item)=>
                  <tr key={item.verif_id} style={{cursor: 'pointer'}}
                     onClick={()=>this.props.dispatch(push(`/deposits/${item.depo_id}/verifications/${item.verif_id}`))}>
                  <td><Moment fromNow>{item.timestamp}</Moment></td>
                  <td>{item.contract_id}</td>
                  <td>{item.prod_name}</td>
                  <td><Status status={item.status} /></td>
              </tr>
              )}
            </tbody>
          </Table>
        </InfoBox>
        <InfoBox xs={6} title="Recent deliveries and last verification status (last 20)">
          <Table size='sm' hover>
            <thead>
              <tr>
                <th>Date created</th>
                <th>SF Contract No, Delivery spec &amp; Date-Time</th>
                <th style={{textAlign: 'right'}}>Status latest</th>
              </tr>
            </thead>
            <tbody>
            {this.props.recentDeposits.map((item)=>
              <tr key={item._id} style={{cursor: 'pointer'}}
                  onClick={()=>this.props.dispatch(push(`/deposits/${item._id}/`))}>
                <td><Moment fromNow>{item.timestamp}</Moment></td>
                <td>{item.name}</td>
                <td><Status status={item.status} /></td>
              </tr>
            )}
            </tbody>
          </Table>
        </InfoBox>
       </Row>

    else
	return "Use the link on the left side to register a new user or log in with an existing user!";

  }
}
const mapDispatchToProps = (dispatch) => ({
  dispatch:  dispatch,
  fetchRecents: () => dispatch(fetchRecents())
})

const mapStateToProps = (state) => ({
  fetching: state.dashboard.fetching,
  recentVerifications: state.dashboard.recentVerifications,
  recentDeposits: state.dashboard.recentDeposits,
})

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js